import React, { FC } from 'react';
import { IconType } from '.';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ListIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={13}
        y1={5}
        x2={30}
        y2={5}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={13}
        y1={16}
        x2={30}
        y2={16}
        strokeLinejoin="miter"
      />
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={13}
        y1={27}
        x2={30}
        y2={27}
        strokeLinejoin="miter"
      />
      <circle
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        cx={5}
        cy={5}
        r={3}
        strokeLinejoin="miter"
      />
      <circle
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        cx={5}
        cy={16}
        r={3}
        strokeLinejoin="miter"
      />
      <circle
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        cx={5}
        cy={27}
        r={3}
        strokeLinejoin="miter"
      />
    </svg>
  );
};
